import { useState, useEffect } from 'react';
import './FacilityTagsModal.css';
import * as Yup from 'yup';
import Form from '../../../components/form/components/Form/Form';
import FormField from '../../../components/form/components/FormField/FormField';
import Button from '../../../components/form/components/Button/Button';
import ErrorMessage from '../../../components/form/components/ErrorMessage/ErrorMessage';
import { ImCancelCircle } from 'react-icons/im';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import { auth } from '../../../firebase/firebase-config';

import { useAuthState } from 'react-firebase-hooks/auth';
import { createFacilityTag, getAllTagsCategories, updateFacilityData, updateFacilityTag } from "../../../services/facilities";
import { Select } from 'antd';

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const override = {
    marginTop: '20px'
};

let { Option } = Select;

function FacilityTagsModal({ onClose, onContentAdded, editData = null } : any) {
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [allCategories, setAllCategories] = useState([])
    const [selectedCategory, setSelectedCategory] = useState(null);
    const isEditMode = !!editData;

    const [initialValues, setInitialValues] = useState({
        name: editData?.name || '',
        nameFr: editData?.nameFr || '' // Add French name to initial values
    });

    const [user] = useAuthState(auth);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        nameFr: Yup.string() // Optional French name validation
    })

    const fetchCategories = () => {
        getAllTagsCategories().then((res: any) => {
            setAllCategories(res?.data);
        })
    }

    const handleSubmitData = async (values: any) => {
        try {
            setLoading(true);

            if(selectedCategory == null) {
                setLoading(false);
                toast.error("Select Category", {
                    pauseOnHover: false,
                    closeOnClick: true,
                });
                return;
            }

            let reqData = {
                ...values,
                category: selectedCategory
            };

            if(isEditMode) {
                // Update
                await updateFacilityTag(editData.id, reqData);
                toast.success('Facility Tag updated successfully');
            } else {
                // Create
                await createFacilityTag(reqData);
                setLoading(false);
                onContentAdded();
                toast.success("Tag created successfully", {
                    pauseOnHover: false,
                    closeOnClick: true,
                });
            }
        } catch (error) {
            console.log('Error: ', error)
            setLoading(false);

            toast.error("Error Creating", {
                pauseOnHover: false,
                closeOnClick: true,
            });
        } finally {
          onContentAdded();
            setLoading(false);
            onClose();
        }
    }

    useEffect(() => {
        fetchCategories();
        if (isEditMode && editData?.category) {
            setSelectedCategory(editData.category);
        }
    }, [editData]);

    return (
        <div>
            <div className='modal-container student-modal-assignment' id="tags-category-modal">
                <div className='modal-head'>
                    <p className="modal-title">Tag Data</p>
                    <ImCancelCircle style={{cursor: 'pointer'}} onClick={onClose} size={22} color="#fff"/>
                </div>
                <div className='modal-content'>
                    <div style={{textAlign: 'center', marginBottom: '10px'}}>
                        <BeatLoader
                            color="#3080ED" 
                            loading={loading}
                            cssOverride={override}
                        />
                    </div>
                    <form action="" className="auth-form">
                        {error && <ErrorMessage error={error} visible={true} />}
                        <Form 
                            initialValues={initialValues}
                            onSubmit={handleSubmitData}
                            validationSchema={validationSchema}
                        >
                            <p className="label-text">Tag Name (English): </p>
                            <FormField name="name" type="text" placeholder="Enter tag name"/>

                            <p className="label-text">Tag Name (French): </p>
                            <FormField name="nameFr" type="text" placeholder="Enter French tag name (optional)"/>

                            <p className="label-text">Select tag category: </p>
                            <Select
                                className={'slide_select'}
                                showSearch
                                style={{ width: 200 }}
                                placeholder="Search to Select"
                                optionFilterProp="label"
                                value={selectedCategory}
                                popupClassName="dropDownItems"
                                filterOption={(input: any, option: any) =>{
                                    return (option?.children as string)?.toLowerCase()?.includes((input as string)?.toLowerCase());
                                }}
                                onSelect={(val: any) => setSelectedCategory(val)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.children ?? '').toLowerCase().localeCompare((optionB?.children ?? '').toLowerCase())
                                }
                            >
                                {allCategories.map((option: any, index: any) => (
                                    <Option key={index} value={option.name}>
                                        {option.name}
                                    </Option>
                                ))}
                            </Select>

                            <br />
                            <br />
                            {!loading && <Button isOutLined={true} isFullWidth={false} title={isEditMode ? 'UPDATE DATA' : "SUBMIT DATA"}/>}
                        </Form>
                    </form>
                </div>
            </div>
            <div className="modal-shadow" onClick={onClose}></div>
        </div>
    );
}

export default FacilityTagsModal;